import { AppState } from '@/store';
import { uniqBy } from 'lodash';

export const onBoardingFixedBlock = (state: AppState) => state.onboarding?.fixedBlock || null;
export const selectOnBoardingInfo = (state: AppState) => state.onboarding?.user?.userOnboarding || null;
export const selectUserProfileInfo = (state: AppState) => state.onboarding?.user?.userProfile || null;
export const userDetails = (state: AppState) => state.onboarding?.user || null;
export const selectUserLoading = (state: AppState) => state.onboarding?.userLoading;
export const selectSetup = (state: AppState) => state.onboarding?.accountStatus;
export const selectUserOnboarding = (state: AppState) => state.onboarding;
export const userAddressData = (state: AppState) => state.onboarding?.user?.addresses || null;
export const selectContacts = (state: AppState) => state.onboarding?.contacts ?? [];
export const selectOnboardingUser = (state: AppState) => state.onboarding.user;
export const selectInsuranceLookupTriggered = (state: AppState) => state.onboarding.insuranceLookupTriggered;
export const selectCreditCards = (state: AppState) => state.onboarding?.user?.creditCards || [];
export const selectOnboardingIsIntroduction = (state: AppState) => state.onboarding.isIntroductionScreen;
export const hasPregnancy = (state: AppState) => state.onboarding?.hasPregnancy || false;
export const selectIsOnlyOneMedication = (state: AppState) => state.onboarding.isOnlyOneMedication;
export const selectUserUserOnboarding = (state: AppState) => state.onboarding.user?.userOnboarding;
export const selectEligibilityFailedModalOpen = (state: AppState) => state.onboarding.elibigilityFailedPopupOpen;
export const selectPrescriptionsProviders = (state: AppState) =>
    uniqBy(
        state.onboarding.user?.transferPrescriptions.filter(medication => !!medication?.provider)?.map(med => med.provider),
        'phoneNumber'
    );

export const selectPrescriptionsPharmacies = (state: AppState) =>
    uniqBy(
        state.onboarding.user?.transferPrescriptions.filter(medication => !!medication?.fromPharmacy)?.map(med => med.fromPharmacy),
        'phone'
    );
export const selectIsScrollVisible = (state: AppState) => state.onboarding?.isScrollVisible || false;
export const selectIsOpenedHelper = (state: AppState) => state.onboarding?.isOpenedHelper;
export const selectSelectedMedication = (state: AppState) => state.onboarding?.selectedMedication;
export const selectIsPopoverAutocompleteOpen = (state: AppState) => state.onboarding?.isPopoverAutocompleteOpen;
export const selectRegisterData = (state: AppState) => state.onboarding.registerData;